import component from './PhTicket.vue_vue_type_script_lang.vue.js';
export { default } from './PhTicket.vue_vue_type_script_lang.vue.js';
import { render } from './PhTicket.vue_vue_type_template_id_7eb91a0a_lang.vue.js';

component.render = render;
